import envConfig from '@ey/voltron-config';

const config = {...envConfig.ad};
config.versionCheckUrl = envConfig.serviceUrl;
export default config;
